export default "__VITE_ASSET__gSb010vu__"